import { render } from "./Methods.vue?vue&type=template&id=0840fc74&scoped=true"
const script = {}

import "./Methods.vue?vue&type=style&index=0&id=0840fc74&scoped=true&lang=css"

import exportComponent from "/home/runner/work/helixpay-website/helixpay-website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0840fc74"]])

export default __exports__